<div id="pspdfkit" [style.height]="height"></div>
